
import { BuildInfo } from "./build-info";

export const getBuildInfo = () => BuildInfo;